import ClientPortalRequestsRoutes from './ClientPortalRequestsRoutes';

export default ClientPortalRequestsRoutes;
